import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Input, Space, Col, Row, Divider } from "antd";
import axios from "axios";
import { toast } from "react-toastify";
import {
  EditOutlined,
  SearchOutlined
} from "@ant-design/icons";
import {
  GetPendingLeaveList,
  UpdateApproveRejectLeave
} from "../../../AllAPI/AdminAPI";

const LeaveAppPendingList = () => {

  const storedBranchId = sessionStorage.getItem("branch_id");
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
//   const [updatedStatus, setUpdatedStatus] = useState(null);

  // FETCH LEAVE DATA
  const fetchLeaveData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${GetPendingLeaveList}/${storedBranchId}/${BoardingYear}`);

      const formatted = res.data.map((item, index) => ({
        key: index + 1,
        id: item.id,
        full_name: item.student.full_name,
        reason: item.reason,
        from_date: item.from_date,
        to_date: item.to_date,
        status: item.status,
      }));

      setData(formatted);
    } catch (error) {
      toast.error("Failed to load leave applications");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaveData();
  }, []);

  // OPEN EDIT MODAL
  const handleEdit = (record) => {
    setSelectedRecord(record);
    setSelectedId(record.id);
    setIsModalOpen(true);
  };

  // UPDATE STATUS FUNCTION
  const handleSave = async (updatedStatus) => {
    if (!selectedId) return;

    const payloadUpdate = { status: updatedStatus };

    try {
      setLoading(true);
      const res = await axios.put(
        `${UpdateApproveRejectLeave}/${selectedId}`,
        payloadUpdate
      );

      if (res.data === "APPROVED") {
        toast.success("Leave Status Updated Successfully");
        fetchLeaveData(); 
        setIsModalOpen(false);
      }
      else if (res.data === "REJECTED") {
        toast.success("Leave Status Updated Successfully");
        fetchLeaveData(); 
        setIsModalOpen(false);
      }
      else if (res.data == "ERROR") {
              toast.warn("Some error occurred! Please try again later")
            }
    } catch (error) {
      toast.error("Failed to update leave status");
    } finally {
      setLoading(false);
    }
  };

  // APPROVE
  const onApprove = () => {
    // setUpdatedStatus(2);
    handleSave(2);
  };

  // REJECT
  const onReject = () => {
    // setUpdatedStatus(3);
    handleSave(3);
  };

  // STATUS LABEL
  const getStatusLabel = (status) => {
    if (status === 2)
      return (
        <span style={{ color: "green", background: "#d2faed", padding: "5px 10px", borderRadius: 10 }}>
          Approved
        </span>
      );
    if (status === 3)
      return (
        <span style={{ color: "red", background: "#fad2d2", padding: "5px 10px", borderRadius: 10 }}>
          Rejected
        </span>
      );
    if (status === 0)
      return (
        <span style={{ color: "#ff7301", background: "#f7fdbb", padding: "5px 10px", borderRadius: 10 }}>
          Pending
        </span>
      );
  };

  // TABLE COLUMNS
  const columns = [
    { title: "No.", dataIndex: "key", width: 60 },
    { title: "Name", dataIndex: "full_name" },
    { title: "Reason", dataIndex: "reason" },
    { title: "From Date", dataIndex: "from_date" },
    { title: "To Date", dataIndex: "to_date" },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            size="small"
            onClick={() => handleEdit(record)}
            disabled={record.status === 3} // DISABLE FOR REJECTED
          />
        </Space>
      ),
    },
  ];

  // SEARCH FILTER
  const filteredData = data.filter((item) =>
    (item.reason ?? "").toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Leave Approval Pending List</h2>
          </div>

          <div className="search-bar">
            <Input
              placeholder="Search reason..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: "max-content" }}
          />

          {/* MODAL */}
          <Modal
                title="Leave Details"
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}   // remove old footer, add custom responsive footer below
                >
                {selectedRecord && (
                    <>
                    <div style={{ padding: "10px 0" }}>
                        <Row gutter={[0, 12]}>
                        
                        <Col span={24}>
                            <span style={{fontWeight:"600"}}>Reason:</span>
                            <div style={{ 
                            background: "#f5f5f5", 
                            padding: "10px", 
                            borderRadius: "8px",
                            marginTop: "5px"
                            }}>
                            {selectedRecord.reason}
                            </div>
                        </Col>

                        <Col span={12}>
                            <span style={{fontWeight:"600"}}>From Date:</span>
                            <div style={{ 
                            background: "#f5f5f5", 
                            padding: "10px", 
                            borderRadius: "8px",
                            marginTop: "5px"
                            }}>
                            {selectedRecord.from_date}
                            </div>
                        </Col>

                        <Col span={12}>
                            <span style={{fontWeight:"600"}}>To Date:</span>
                            <div style={{ 
                            background: "#f5f5f5", 
                            padding: "10px", 
                            borderRadius: "8px",
                            marginTop: "5px"
                            }}>
                            {selectedRecord.to_date}
                            </div>
                        </Col>

                        <Col span={24}>
                            <span style={{fontWeight:"600"}}>Status:</span>
                            <div style={{ marginTop: "5px" }}>
                            {getStatusLabel(selectedRecord.status)}
                            </div>
                        </Col>
                        </Row>
                    </div>

                    <Divider />

                    {/* Responsive buttons */}
                    <Row gutter={[10, 10]}>
                        <Col xs={24} sm={8}>
                        <Button 
                            block 
                            onClick={() => setIsModalOpen(false)}
                        >
                            Cancel
                        </Button>
                        </Col>

                        <Col xs={24} sm={8}>
                        <Button 
                            block 
                            danger 
                            onClick={onReject}
                        >
                            Reject
                        </Button>
                        </Col>

                        <Col xs={24} sm={8}>
                        <Button 
                            block 
                            type="primary" 
                            onClick={onApprove}
                        >
                            Approve
                        </Button>
                        </Col>
                    </Row>
                    </>
                )}
                </Modal>

        </div>
      </div>
    </div>
  );
};

export default LeaveAppPendingList;
